import React, { useState, useEffect } from 'react';
import { resolveFileUrl } from '../../utils/resolveFileUrl';

/**
 * GroupAvatar Component
 * Handles avatar display with automatic URL resolution
 */
const GroupAvatar = ({ group, size = 'md', className = '' }) => {
  const [resolvedAvatarUrl, setResolvedAvatarUrl] = useState(null);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const resolveAvatar = async () => {
      const avatarUrl = group?.avatar_url || group?.avatarUrl;
      if (avatarUrl) {
        try {
          const resolved = await resolveFileUrl(avatarUrl);
          setResolvedAvatarUrl(resolved);
          setImageError(false);
        } catch (error) {
          console.warn('Failed to resolve avatar URL:', error);
          setResolvedAvatarUrl(avatarUrl);
          setImageError(false);
        }
      } else {
        setResolvedAvatarUrl(null);
      }
    };
    resolveAvatar();
  }, [group?.avatar_url, group?.avatarUrl]);

  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name[0]?.toUpperCase() || '?';
  };

  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-sm',
    xl: 'w-20 h-20 text-xl',
    full: 'w-full h-full text-sm',
  };

  const sizeClass = sizeClasses[size] || sizeClasses.md;

  return (
    <div className={`${sizeClass} rounded-full bg-primary flex items-center justify-center font-semibold text-gray-900 overflow-hidden ${className}`}>
      {resolvedAvatarUrl && !imageError ? (
        <img
          src={resolvedAvatarUrl}
          alt={group?.name || 'Group'}
          className="w-full h-full rounded-full object-cover"
          onError={() => setImageError(true)}
        />
      ) : (
        <span className="font-bold">
          {getInitials(group?.name || '?')}
        </span>
      )}
    </div>
  );
};

export default GroupAvatar;
